<template>
    <div
        id="settingspage"
        class="uses-tailwind grid grid-cols-12 items-stretch gap-8 p-4"
    >
        <div
            v-for="card in cards"
            class="col-span-full sm:col-span-6 md:col-span-4 lg:col-span-3 flex flex-col items-center justify-center bg-primary-light border-slate-200 rounded border-2 shadow text-center text-white font-bold cursor-pointer hover:shadow-lg transition-all group/card aspect-[4/3] 4xl:aspect-[2/1]"
            @click="$router.push(card.route)"
        >
            <h2 class="xl:text-xl text-lg mb-10 md:mb-5 xl:mb-10 font-bold">
                {{ card.label }}
            </h2>
            <i
                class="fa text-[3em] xl:text-[4em] 2xl:text-[5em] group-hover/card:scale-110 transition-all mb-10 md:mb-5 xl:mb-10"
                v-bind:class="card.icon"
            />
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            cards: [],
        };
    },
    mounted() {
        if (this.isAdmin || this.isSuperAdmin) {
            this.cards.push({
                label: this.trans('pages.settings.product_types'),
                icon: 'fa-wrench',
                route: '/settingsProducttypes',
            });
            this.cards.push({
                label: this.trans('pages.settings.parameters'),
                icon: 'fa-sliders',
                route: '/settingsSchedule',
            });
            this.cards.push({
                label: this.trans('pages.settings.profile_info'),
                icon: 'fa-archive',
                route: '/settingsProfile',
            });
            this.cards.push({
                label: this.trans('pages.settings.workstations'),
                icon: 'fa-briefcase',
                route: '/settingsworkstationtypes',
            });
            this.cards.push({
                label: this.trans('pages.settings.articles'),
                icon: 'fa-tags',
                route: '/settingsarticles',
            });
            this.cards.push({
                label: this.trans('pages.settings.product_type_groups'),
                icon: 'fa-sitemap',
                route: '/product-type-groups',
            });
        }
        if (
            this.isAdmin ||
            this.isSuperAdmin ||
            this.isProductionManagement ||
            this.isProduction
        ) {
            this.cards.push({
                label: this.trans('pages.settings.stock_locations'),
                icon: 'fas fa-warehouse',
                route: '/settingsstocklocations',
            });
        }
        this.cards.push({
            label: this.trans('pages.settings.application_settings'),
            icon: 'fas fa-tablet',
            route: '/appsettings',
        });
        this.cards.push({
            label: this.trans('pages.settings.errors'),
            icon: 'fas fa-exclamation-circle',
            route: '/errors',
        });
        if (this.isAdmin || this.isSuperAdmin) {
            this.cards.push({
                label: this.trans('pages.settings.material_types'),
                icon: 'fas fa-layer-group',
                route: '/material-types',
            });
            this.cards.push({
                label: 'Printers',
                icon: 'fas fa-print',
                route: '/settingsprinters',
            });
        }
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
        isAdmin() {
            return this.hasRight('administration');
        },
        isSuperAdmin() {
            return this.hasRight('admin');
        },
        isProductionManagement() {
            return this.hasRight('productionmanagement');
        },
        isProduction() {
            return this.hasRight('production');
        },
    },
};
</script>
